/** Original static launch mascot; the label is for screen readers only. */
export function MascotLoading({ label = "Loading Lift & Learn" }: { label?: string }) {
  return (
    <div className="mascot-loading" role="status" aria-label={label}>
      <img src="/images/launch-mascot.png" alt="" width="200" height="200" />
    </div>
  );
}
